// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfigSeparator_container__PkfjJ"};